import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PrizeLevelModalPage } from './prize-level-modal';

@NgModule({
  declarations: [
    PrizeLevelModalPage,
  ],
  imports: [
    IonicPageModule.forChild(PrizeLevelModalPage),
  ],
  exports: [
    PrizeLevelModalPage
  ]
})
export class PrizeLevelModalPageModule {}



// WEBPACK FOOTER //
// ./src/app/lottery/prize-level-modal/prize-level-modal.module.ts